// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b31fd5f6","455":"0b727a1f","598":"1f2fa7dc","602":"e597cded","865":"b56b576b"}[chunkId] + ".chunk.js";
};